<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 9/9/2021
  -->

<template>
<div></div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import BillingData from "@shared/Billing/BillingData";
import CoachingProgram from "@shared/Program/CoachingProgram";
import BillingItem, {PaymentStatus} from "@shared/Billing/BillingItem";
import {deleteConfirmDialog} from '@/core/components/Dialogs/dialog'
import PersonItem from "@shared/Invoice/PersonItem";
import {InvoiceCommand} from "@shared/Invoice/InvoiceItem";
import InvoiceGroup from "@shared/Invoice/InvoiceGroup";

import ConfirmedPaymentDialog from './../Dialogs/ConfirmedPaymentDialog'
import InvoiceDetailsDialog from './../Dialogs/InvoiceDetailsDialog'
import CreateInvoiceDialog from './../Dialogs/CreateInvoiceDialog'
import EditTimeEntryDialog from './../Dialogs/EditTimeEntryDialog'
import {createDialogLazy} from "@/utils/helpers-external";

let confirmedPaymentDialog = createDialogLazy(ConfirmedPaymentDialog)
let invoiceDetailsDialog = createDialogLazy(InvoiceDetailsDialog)
let createInvoiceDialog = createDialogLazy(CreateInvoiceDialog)

let editTimeEntryDialog = createDialogLazy(EditTimeEntryDialog)


export default {
	name: "BasePaymentTypePanel",
	extends: BaseComponent,
	props: {
		billingData: {BillingData, required: true},
		invoices: {Array, required: true},
		programItem: {CoachingProgram, required: true},
		disableInvoices: {Boolean, default: false},
		isSavingBillingData: Boolean,
        hidePaymentMethodsView: Boolean,
        modal: {Boolean, default: true},
        modalSize: String,
		clients: {Array, required: true}

	},

	watch:{
		billingData:{
			immediate: true,
			handler(){
				if(!this.isBillingDataLoaded){
					this.onBillingDataReady()
				}
				this.isBillingDataLoaded = true
			}
		}
	},

	data: () => {
		return {
			isEmitDataChangePending: false,
			isBillingDataLoaded: false
		}
	},

	methods: {

        async validate(){
            return this.validateForm()
        },

		onBillingDataReady(){

		},

		findInvoiceGroupForBillingItemId(billingItemId) {
			let group = this.invoices.find(invoiceGroup => invoiceGroup.findInvoiceByBillingItemId(billingItemId))
			return group
		},

		isProgramStepAlreadyUsed(step) {
			return this.billingData.findBillingItemByMilestoneSectionId(step.id) != null
		},

		onDataChanged() {
			this.$emit("onDataChanged", this.billingData, this)
		},

		onAddMilestoneClicked() {
			let _ = this.$analyticManager.trackEvent("Add payment milestone clicked", this.analyticsPropsMethod())
			let item = new BillingItem();
			item.billingType = this.billingData.billingType
			this.billingData.billingItems.push(item)
			this.onDataChanged()
		},

		async onDeleteMilestoneClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Delete payment milestone clicked", this.analyticsPropsMethod())
			let shouldDelete = await deleteConfirmDialog({itemName: billingItem.isHourly ? "time entry" : "payment milestone"})
			if (shouldDelete) {
				this.billingData.removeBillingItemById(billingItem.id)
				this.onDataChanged()
			}
		},




		onBillingItemRowClicked(billingItem, invoiceGroup) {
			console.log("onBillingItemRowClicked: billingItem = ", billingItem, ", invoiceGroup = ", invoiceGroup)
			invoiceGroup = invoiceGroup || this.findInvoiceGroupForBillingItemId(billingItem.id)
			if (invoiceGroup.isPaid()) {
				this.onConfirmedPaymentClicked(billingItem)
			} else if (invoiceGroup.isInvoiced() || invoiceGroup.isConfirmPending()) {
				this.onManualPaymentConfirmClicked(billingItem)
			}
		},
		onConfirmedPaymentClicked(billingItem) {
			let invoiceGroup = this.findInvoiceGroupForBillingItemId(billingItem.id)
			console.log("onConfirmedPaymentClicked: invoiceGroup = ", invoiceGroup)
			console.log("onConfirmedPaymentClicked: billingItem = ", billingItem)
			console.log("onConfirmedPaymentClicked: this.invoices = ", this.invoices)
			confirmedPaymentDialog(this.billingData, billingItem, invoiceGroup)
				.then(data => {
					if (data.command === InvoiceCommand.REMOVE_PAID) {
						invoiceGroup.setPaymentStatus(PaymentStatus.INVOICED)
						this.onInvoiceChanged(invoiceGroup)
						this.onDataChanged()
					}
				})

		},
		async onSendInvoiceClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Create invoice clicked", this.analyticsPropsMethod())
			console.log("onSendInvoiceClicked111")

			let invoiceData = await createInvoiceDialog({
				billingData: this.billingData,
				billingItem: billingItem,
				clients: this.clients,
				invoiceGroupList: this.invoices,
				programItem: this.programItem
			})

			if (invoiceData) {
				let invoiceGroup = invoiceData.invoiceGroup;
				let isConfirmManually = invoiceData.isConfirmManually
				let status = isConfirmManually ? PaymentStatus.PAID : PaymentStatus.INVOICED
				invoiceGroup.setPaymentStatus(status, new Date().getTime())
				this.onInvoiceChanged(invoiceGroup)
				this.onDataChanged()
			}

		},

		async onTimeEntryEditClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Time entry edit clicked", this.analyticsPropsMethod())
			let data = await editTimeEntryDialog({
				billingData: this.billingData,
				billingItem: billingItem
			})
			if (data) {
				this.onDataChanged()
			}
		},


		clientsToPersonItems() {
			return this.clients.map(client => new PersonItem(client.id, client.name, client.email))
		},

		async onManualPaymentConfirmClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Manual payment confirm clicked", this.analyticsPropsMethod())
			let paidDate = new Date();

			let invoiceGroup = this.findInvoiceGroupForBillingItemId(billingItem.id)
			if (invoiceGroup) {
				let paidDateTs = invoiceGroup.paidDateTsIfAllSame()
				if (paidDateTs) {
					paidDateTs = new Date(paidDateTs)
				}
			}

			let data = await invoiceDetailsDialog(this.billingData, billingItem, invoiceGroup, paidDate)
			console.log("paidConfirmDialog: data = ", data)
			if (!data) {
				return
			}
			let paidDateTs = data.paidDate.getTime()
			let command = data.command;
			switch (command) {
				case InvoiceCommand.CONFIRM: {
					invoiceGroup.setPaymentStatus(PaymentStatus.PAID, paidDateTs)
					this.onInvoiceChanged(invoiceGroup)
					break;
				}
				case InvoiceCommand.CREATE_CONFIRMED: {
					let invoiceGroup = new InvoiceGroup();
					invoiceGroup.createInvoiceForAll(this.clientsToPersonItems(), this.billingData, [billingItem.id], this.currencyItemGlobal)
					invoiceGroup.setBillFrom(new PersonItem(this.userProfile.id, this.userProfile.name, this.userProfile.email))
					invoiceGroup.setPaymentStatus(PaymentStatus.PAID, paidDateTs)
					invoiceGroup.setIsEmailSent(true)
					this.onInvoiceChanged(invoiceGroup)
					break;
				}
				case InvoiceCommand.CREATE:
					await this.onSendInvoiceClicked(billingItem)
					break;
				case InvoiceCommand.WITHDRAW: {
					invoiceGroup.setPaymentStatus(PaymentStatus.DELETED)
					this.onInvoiceChanged(invoiceGroup)
					break;
				}
			}
			this.onDataChanged()

		},


		onTimeChanged(billingItem) {
			let _ = this.$analyticManager.trackEvent("Logged time changed", this.analyticsPropsMethod())
			this.onTimeEntryChanged(billingItem)
		},

		onTimeEntryChanged(billingItem) {
			if (!billingItem.isNameSetManually && billingItem.durationMs > 0) {
				billingItem.name = billingItem.durationFormatted()
			}
			this.onDataChanged()
		},




		emitDataChangeDebounced() {
			this.emitDataChange()
		},
		emitDataChange() {
			if (this.isEmitDataChangePending) {
				this.isEmitDataChangePending = false
				this.$emit("change", this.billingData, this)
			}
		},

		onInvoiceChanged(invoiceGroup) {
			invoiceGroup.invalidate()
			invoiceGroup.setCurrencyItem(this.currencyItemGlobal)
			this.emitInvoiceChange(invoiceGroup)
		},

		emitInvoiceChange(invoiceGroup) {
			this.$emit("invoiceGroupUpdated", invoiceGroup, this)
		},

		saveStarted() {
			console.log("saveStarted")
			if (this.$refs.saveIndicator) {
				console.log("saveStarted2")
				this.$refs.saveIndicator.show()
			}
		},
		saveSuccess() {
			console.log("saveSuccess")
			if (this.$refs.saveIndicator) {
				console.log("saveSuccess2")
				this.$refs.saveIndicator.hide()
			}
		},
		saveFailed() {
			if (this.$refs.saveIndicator) {
				this.$refs.saveIndicator.hideNoMessage()
			}
		},

		logClick(canEdit, billingItem) {
			console.log("canEdit = ", canEdit, ", billingItem = ", billingItem.id)
		},

		analyticsPropsMethod() {
			return {
				category: "Program billing panel",
				billing_type: this.billingData.isHourly ? "hourly" : "fixed",
				program_id: this.programItem.id,
				program_name: this.programItem.name,
			}
		},
	},

	computed: {
		isProgramTemplate() {
			return this.programItem.isTemplate()
		}
	},
}
</script>

<style lang="scss">

</style>
